import { Injectable, inject } from "@angular/core";
import { ApiWrapperService } from "ngx-apiwrapper";
import { Payment } from "./models/payments/payment.model";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PaymentService {
    private readonly _apiWrapper = inject(ApiWrapperService);

    processPayment(payment: Payment): Observable<Payment>{
        return this._apiWrapper.post<Payment>('payments/process', payment);
    }
}